// Modules
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs
import { Observable } from 'rxjs';

// Services
import { AppConfigService } from '@shared-module/services/app-config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class ViewProfileService {
  // Private variables
  private _baseUrl: string;

  // Constructor
  constructor(
    private _app: AppConfigService,
    private _httpClient: HttpClient
  ) {}

  // Private method to set the base url
  private _setBaseUrl(): void {
    this._baseUrl = `${this._app.usersConfig.backendBaseUrl}/auth`;
  }

  // Public method to get profile user
  public getUserProfile(): Observable<any> {
    this._setBaseUrl();
    const path = `${this._baseUrl}/profile`;
    return this._httpClient.get(path);
  }
}
